import { ReactElement, forwardRef } from 'react';
import {
  FlowSections,
  FlowSectionsProps,
  FlowSectionsRef,
} from '../../../../shared/component/flow/flow-sections';
import {
  getReorderFromItemParent,
  getReorderToItemParent,
} from '../../../../shared/component/flow/flow-sections.utils';
import { useFlowServices } from '../../../../shared/hook/flow-service.hooks';
import { instanceOfFlowItemSectionParent } from '../../../../shared/util/flow-item.util';
import { instanceOfFlowItemStitchSection } from '../../util/beacon-welding.util';

const WeldingFlowSections = forwardRef<FlowSectionsRef, FlowSectionsProps>(
  (props: FlowSectionsProps, _ref): ReactElement => {
    const { flowAnalyticService } = useFlowServices();

    const onReorderItems: FlowSectionsProps['onReorderItems'] = (params) => {
      const { fromIndex, toIndex, items } = params;

      const fromItem = items[fromIndex];
      const fromItemIsParent = instanceOfFlowItemSectionParent(fromItem);

      if (instanceOfFlowItemStitchSection(fromItem)) {
        flowAnalyticService.trackReorderFlowItemStitch({
          isParent: fromItemIsParent,
          fromParentId: getReorderFromItemParent({
            from: fromIndex,
            to: toIndex,
            actualItems: items,
          }),
          toParentId: getReorderToItemParent({
            from: fromIndex,
            to: toIndex,
            actualItems: items,
          }),
        });
      }
    };

    return <FlowSections {...props} onReorderItems={onReorderItems} />;
  }
);

WeldingFlowSections.displayName = 'WeldingFlowSections';

export { WeldingFlowSections };
